import { Component } from "react";

export class ErrorBoundary extends Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError() {
    return { hasError: true };
  }

  componentDidCatch(error, info) {
    console.error("Erro nao tratado:", error, info);
  }

  render() {
    if (!this.state.hasError) return this.props.children;

    return (
      <div className="flex min-h-screen flex-col items-center justify-center gap-5 bg-[#050505] px-6 text-center">
        <p className="font-['Cormorant_Garamond'] text-3xl text-white">Algo deu errado</p>
        <p className="max-w-sm font-['Manrope'] text-sm font-light text-white/60">
          Ocorreu um erro inesperado nesta tela. Recarregue a página para continuar.
        </p>
        <button
          type="button"
          onClick={() => window.location.reload()}
          className="rounded-md bg-[#CC0000] px-6 py-3 font-['Manrope'] text-xs font-semibold uppercase tracking-[0.14em] text-white transition hover:bg-[#A80000]"
        >
          Recarregar
        </button>
      </div>
    );
  }
}
